/**
 * Template: Password
 * -----------------------------------------------------------------------------
 * Password template functionality.
 *
 */

/**
 * DOM selectors.
 */
const selectors = {
  loginForm: '.password__form-container',
  showLoginLink: '.password__link',
};

export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    loginForm: document.querySelector(selectors.loginForm),
    showLoginLink: document.querySelector(selectors.showLoginLink),
  };

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners();
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    nodeSelectors.showLoginLink?.addEventListener('click', () => {
      nodeSelectors.loginForm?.classList.toggle('hidden');
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
